<template>
  <div class="notes-truck">
    <div class="title custom-title flex">
      Billing Information
      <div class="red">*</div>
    </div>
    <b-card class="b-card-bg">
      <validation-observer name="billing" ref="validateBilling">
        <validation-provider
          name="Billing Information"
          #default="{ errors }"
          rules="required"
        >
          <b-form-group>
            <b-form-textarea
              :disabled="readonly"
              class="iuput height-input"
              v-model="value.billingInformation"
              placeholder="Please provide billing Lift on -Lift of (Lo-Lo), other charges for third party, and direct billing from shipping lines."
              required
            ></b-form-textarea>

            <small class="text-danger" v-show="errors.length > 0">{{
              errors[0]
            }}</small>
          </b-form-group>
        </validation-provider>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
  BButton,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    Select2,
  },
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      "quotations",
      "locations",
    ]),
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
.notes-truck {
  .custom-title {
    align-items: center;
    display: flex;
    height: 43px;
  }
  .container-checkbox {
    display: flex;
    margin-top: 29px;
    align-items: center;
    gap: 5px;
  }
  label {
    color: #000000;
    font-weight: 600;
  }
  .form-control {
    border: 0 !important;
  }
  .b-card-bg {
    background-color: white;
    height: auto;
    padding: 1.5rem;
    @media (max-width: 992px) {
      height: 350px;
    }
  }
}
</style>
